import {computedAsync, type AsyncComputedOnCancel, type AsyncComputedOptions} from '@vueuse/core';
import {shallowRef, triggerRef, type Ref} from 'vue';

/**
 * Extends {@link computedAsync} to enable manual reload
 */
export function computedAsyncWithReload<T>(
    evaluationCallback: (onCancel: AsyncComputedOnCancel) => T | Promise<T>,
    initialState: T,
    optionsOrRef?: Ref<boolean> | AsyncComputedOptions
) {
    const reloadRef = shallowRef();

    function reload() {
        triggerRef(reloadRef);
    }

    const state = computedAsync(
        onCancel => {
            reloadRef.value;

            return evaluationCallback(onCancel);
        },
        initialState,
        optionsOrRef
    );

    return {state, reload};
}
